import { BASE_URL, request } from "./api";
import type { Piece } from "./types";

// GET /api/Pieces
export const getPieces = (): Promise<Piece[]> => {
  return request<Piece[]>(`${BASE_URL}/api/Pieces`, { method: "GET" });
};

// GET /api/Pieces/{id}
export const getPieceById = (id: number): Promise<Piece> => {
  return request<Piece>(`${BASE_URL}/api/Pieces/${id}`, { method: "GET" });
};

// POST /api/Pieces
export const createPiece = (data: { pieza: string }): Promise<Piece> => {
  return request<Piece>(`${BASE_URL}/api/Pieces`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data,
  });
};